<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 38 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5 22.5019H11.5013H36.9547C37.0991 22.5019 37.2377 22.4446 37.3402 22.3421L37.3405 22.3418C37.4424 22.24 37.5 22.1012 37.5 21.9565V1.04599C37.5 0.90126 37.4424 0.762482 37.3405 0.660698L37.3402 0.660378C37.2377 0.557901 37.099 0.500536 36.9547 0.500536L11.5013 0.500538L11.5 0.500534C11.3561 0.500156 11.2174 0.557182 11.1144 0.659521C11.1143 0.659658 11.1142 0.659798 11.114 0.659935L0.660579 11.1145L0.660252 11.1149C0.55764 11.2173 0.5 11.3562 0.5 11.5012C0.5 11.6463 0.557641 11.7852 0.660251 11.8876L0.660579 11.888L11.114 22.3425C11.1141 22.3426 11.1142 22.3427 11.1143 22.3428C11.2172 22.4452 11.356 22.5023 11.5 22.5019ZM36.9547 23.0019H11.5013L37.6937 22.6956C37.4976 22.8918 37.2318 23.0019 36.9547 23.0019Z" :stroke="fill"/>
    <rect :fill="fill" height="2" rx="1" transform="rotate(135 32.364 6.04883)" width="16" x="32.364" y="6.04883"/>
    <rect :fill="fill" height="2" rx="0.999999" transform="rotate(-135 30.9497 17.3633)" width="16" x="30.9497" y="17.3633"/>
  </svg>
</template>

<script>
export default {
  name: 'Delete',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
